import { useAuthentication } from './useAuthentication';

/** Return authenticated user ID  */
export const useGetUserID = (): string | undefined => {
    const { userId: userID } = useAuthentication();

    return userID;
};
